<template>
  <form>
    <div class="panel panel-grey m-b-xl">
      <div class="panel-body">
        <h3>Linked Social Media Links</h3>

        <p>Add your public social media links below to make them available from your profile.</p>

        <div class="row">
          <div :class="$v.stateFacebookLink.$invalid ? 'col-md-6 form-group has-error' : 'col-md-6 form-group'">
            <div class="social-link-outer">
              <span class="social-link">
                <i class="fab fa-facebook social-icon"></i>
                <input
                  type="text"
                  class="form-control"
                  name="facebook_link"
                  v-model.lazy="$v.stateFacebookLink.$model">
              </span>
              <div class="input-group" v-if="$userIsAdmin || $userIsIntern">
                <input v-model="stateFacebookCount" type="text" class="form-control">
              </div>
              <span v-if="$v.stateFacebookLink.$invalid" class="help-block pull-right">The Facebook field is not a valid URL</span>
            </div>
          </div>
          <div :class="$v.stateTwitterLink.$invalid ? 'col-md-6 form-group has-error' : 'col-md-6 form-group'">
            <div class="social-link-outer">
              <span class="social-link">
                <i class="fab fa-twitter social-icon"></i>
                <input
                  type="text"
                  class="form-control"
                  name="twitter_link"
                  v-model.lazy="$v.stateTwitterLink.$model">
              </span>
              <div class="input-group" v-if="$userIsAdmin || $userIsIntern">
                <input v-model="stateTwitterCount" type="text" class="form-control">
              </div>
              <span v-if="$v.stateTwitterLink.$invalid" class="help-block pull-right">The Twitter field is not a valid URL</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div :class="$v.stateInstagramLink.$invalid ? 'col-md-6 form-group has-error' : 'col-md-6 form-group'">
            <div class="social-link-outer">
              <span class="social-link">
                <i class="fab fa-instagram social-icon"></i>
                <input
                  type="text"
                  class="form-control"
                  name="instagram_link"
                  v-model.lazy="$v.stateInstagramLink.$model">
              </span>
              <div class="input-group" v-if="$userIsAdmin || $userIsIntern">
                <input v-model="stateInstagramCount" type="text" class="form-control">
              </div>
              <span v-if="$v.stateInstagramLink.$invalid" class="help-block pull-right">The Instagram field is not a valid URL</span>
            </div>
          </div>
          <div :class="$v.stateLinkedinLink.$invalid ? 'col-md-6 form-group has-error' : 'col-md-6 form-group'">
            <div class="social-link-outer">
              <span class="social-link">
                <i class="fab fa-linkedin social-icon"></i>
                <input
                  type="text"
                  class="form-control"
                  name="linkedin_link"
                  v-model.lazy="$v.stateLinkedinLink.$model">
              </span>
              <span v-if="$v.stateLinkedinLink.$invalid" class="help-block pull-right">The LinkedIn field is not a valid URL</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div :class="$v.stateTiktokLink.$invalid ? 'col-md-6 form-group has-error' : 'col-md-6 form-group'">
            <div class="social-link-outer">
              <span class="social-link">
                <i class="fab fa-tiktok social-icon"></i>
                <input
                  type="text"
                  class="form-control"
                  name="tiktok_link"
                  v-model.lazy="$v.stateTiktokLink.$model">
              </span>
              <div class="input-group" v-if="$userIsAdmin || $userIsIntern">
                <input v-model="stateTiktokCount" type="text" class="form-control">
              </div>
              <span v-if="$v.stateTiktokLink.$invalid" class="help-block pull-right">The TikTok field is not a valid URL</span>
            </div>
          </div>
          <div :class="$v.stateYoutubeLink.$invalid ? 'col-md-6 form-group has-error' : 'col-md-6 form-group'">
            <div class="social-link-outer">
              <span class="social-link">
                <i class="fab fa-youtube social-icon"></i>
                <input
                  type="text"
                  class="form-control"
                  name="youtube_link"
                  v-model.lazy="$v.stateYoutubeLink.$model">
              </span>
              <div class="input-group" v-if="$userIsAdmin || $userIsIntern">
                <input v-model="stateYoutubeCount" type="text" class="form-control">
              </div>

              <span v-if="$v.stateYoutubeLink.$invalid" class="help-block pull-right">The YouTube field is not a valid URL</span>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <ladda-button
          type="submit"
          class="btn btn-sm btn-primary"
          :click="handleUpdateSocialMediaLinksCallback">
          Save Changes
        </ladda-button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import { stateMapper } from 'mixins/users'
import { handleServerErrors } from 'utils/http'
import { notify } from 'utils'
import { url } from 'vuelidate/lib/validators'

export default {
  mixins: [stateMapper],

  validations: {
    stateFacebookLink: {
      url
    },
    stateTwitterLink: {
      url
    },
    stateInstagramLink: {
      url
    },
    stateLinkedinLink: {
      url
    },
    stateTiktokLink: {
      url
    },
    stateYoutubeLink: {
      url
    }
  },

  methods: {
    ...mapActions('user', ['updateUser']),

    handleUpdateSocialMediaLinksCallback () {
      if (this.$v.$invalid) {
        notify.error('Validation failed')
        return Promise.resolve()
      }
      return this.validate()
        .then(() => {
          return this.updateUser({
            id: this.user.id,
            payload: {
              profile: {
                facebook_link: this.user.profile.facebook_link,
                twitter_link: this.user.profile.twitter_link,
                instagram_link: this.user.profile.instagram_link,
                linkedin_link: this.user.profile.linkedin_link,
                tiktok_link: this.user.profile.tiktok_link,
                youtube_link: this.user.profile.youtube_link,
                facebook_follower_count: this.user.profile.facebook_follower_count,
                twitter_follower_count: this.user.profile.twitter_follower_count,
                instagram_follower_count: this.user.profile.instagram_follower_count,
                tiktok_follower_count: this.user.profile.tiktok_follower_count,
                youtube_follower_count: this.user.profile.youtube_follower_count
              }
            }
          }).then(() => {
            notify.success('Successfully saved social media links.')
          }).catch((errors) => {
            if (errors.response) {
              handleServerErrors(errors, this.errors)
            } else {
              notify.error('Sorry something has gone wrong, please try again.')
              throw errors
            }
          })
        })
    }
  }
}
</script>
